export function logAxiosResponse(response: any) {
  const base = response.config?.baseURL ?? '';
  console.log('[axios response]', {
    baseURL: base,
    url: response.config?.url,
    status: response.status,
    full: base + response.config?.url,
  });
  return response;
}

export function logAxiosError(error: any) {
  const cfg = error.config || {};
  const base = cfg.baseURL ?? '';
  console.warn('[axios error]', {
    baseURL: base,
    url: cfg.url,
    status: error.response?.status,
    full: base + cfg.url,
  });
  return Promise.reject(error);
}
